import React from 'react';
import Logo from '../images/ais-logo.png';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import '../css/EmployeeLoginPage.css';

/**
 * The log in page component, allowing api connection
 * @component LogIn
 * @return {Component} Log in component
 */
export default function LogInPage() {
  return (
    <div className="login-body">
      <a
        style={{
          fontsize: '120px',
          display: 'flex',
          alignItems: 'center',
          flexWrap: 'wrap',
          padding: 40,
          color: 'white',
        }}
        href="/"
      >
        <ArrowBackIcon />
        <span>&nbsp;Back</span>
      </a>
      <form className="box" method="post">
        <img
          src={Logo}
          alt="logo"
          style={{width: '150px', pointerEvents: 'none'}}
        />
        <h1 style={{marginTop: '-10px'}}>Employee Portal</h1>
        <input type="text" name="" placeholder="Username"></input>
        <input type="password" name="" placeholder="Password"></input>
        <input type="submit" name="" value="Login"></input>
      </form>
      <div className="footer">
        <p className="copyright-text">
          &nbsp; &nbsp; &nbsp; &copy;
          <a style={{fontSize: '14px'}} href="/about">
            {' '}
            Advanced Intelligence Services Corp.
          </a>
          &nbsp; All rights reserved.
        </p>
        <div className="footer-container">
          <a href="/termsofuse">Terms of Use</a>
          <a href="/privacypolicy">Privacy Policy</a>
        </div>
      </div>
    </div>
  );
}
